import { zodKnownFieldDefaultValidation } from '@juvare/platform-shared/features/validation';
import { z } from 'zod';
export const getUserCoursesParamsSchema = z.object({
    username: z.string().trim().min(1),
    client: z.string(),
});
export const awsConfigSchema = z.object({
    awsRegion: z.string(),
    awsAccessKey: z.string(),
    awsSecretKey: z.string(),
});
export const responseCourseSchema = z.intersection(z.object({ Id: z.number() }), z.union([
    z.object({ FullName: z.string(), CompletionDate: z.string() }),
    z.object({ Message: z.string(), CompletionDate: z.literal(false) }),
]));
export const responseUserCoursesSchema = z.object({
    FirstName: z.string().max(zodKnownFieldDefaultValidation.stringMax),
    LastName: z.string().max(zodKnownFieldDefaultValidation.stringMax),
    Username: z.string().max(zodKnownFieldDefaultValidation.stringMax),
    Email: z.string().max(zodKnownFieldDefaultValidation.stringMax),
    Courses: responseCourseSchema.array().optional(),
});
